import { type MaskAdapter } from '.';

let formatter: Intl.NumberFormat;

function getIntl() {
  if (!formatter) {
    formatter = new Intl.NumberFormat('pt-BR', { style: 'decimal', currency: 'BRL', minimumFractionDigits: 2 });
  }

  return formatter;
}

const moneyMask: MaskAdapter = {
  apply: (value: number | string) => {
    if (value === null || value === undefined || value === '') return '';
    return getIntl().format(Number(value) || 0);
  },
  clean: value => {
    value = (value || '').toString().replace(/[^\d,]/gi, '');

    if (!value.includes(',')) {
      value = '0,' + padStart(value, 2, '0');
    }

    const [, cents] = value.split(',');

    if (cents && cents.length !== 2) {
      value = value
        .replace(',', '')
        .replace(/(\d+)?(\d{2})/gi, '$1,$2')
        .replace(/^,/gi, '0,');
    }

    return value.replace(/\./gi, '').replace(',', '.');
  }
};

function padStart(string: string, length: number, chars: string) {
  const strLength = length ? string.length : 0;
  return strLength < length ? createPadding(length - strLength, chars) + string : string || '';
}

function createPadding(length: number, chars: string) {
  return new Array(length).fill(chars).join('');
}

export default moneyMask;
